import React, { useEffect, useState } from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, CircularProgress, Tooltip, Box, InputAdornment, Typography, FormGroup, Checkbox } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { useParams } from 'react-router-dom';
import { addObligationApi, editObligationApi, getConsantApi, getCurrencyApi } from '../apiServices';
import { checkApiStatus, numberWithCommas } from '../../../../utils';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { PageLoader, titanAviationIntance } from '../../../../shared_elements';
import { regexConstants } from '../../../../constants/regEx';
import { useSnackbar } from 'notistack';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { useDispatch, useSelector } from 'react-redux';
import { trackActivity } from '../../../../utils/mixpanel';
import { formatBytes } from '../../../../utils/fileUpload';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const ObligationsCRU = ({ modeType, fileUpload, getResponseBack, onToggleModal, addEditObligation, onOpenAttachments }) => {
    const {storageDetails, leaseBasicDetails} = useSelector((state) => state.leases);
    const leaseStartDate = moment(leaseBasicDetails?.start_date);
    const leaseEndDate = moment(leaseBasicDetails?.end_date);
    const hasLeaseDateRange = leaseStartDate.isValid() && leaseEndDate.isValid();
    const dispatch=useDispatch()
    const { leaseSlug } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const params = { leaseSlug: leaseSlug };
    const [data, setData] = useState(() => {if (addEditObligation?.data?.to_be_approved_by) {const name = addEditObligation?.data?.to_be_approved_by?.name || "";const [first_name = "", last_name = ""] = name.split(" "); return { ...addEditObligation?.data, to_be_approved_by: { ...addEditObligation?.data?.to_be_approved_by, first_name, last_name, }, }; }return addEditObligation?.data;});    
    const [isLoading, setLoading] = useState(false);
    const [dropDownLoader, setDropDownLoader] = useState({ constant: false, user: false, currency: false });
    const [pltConstants, setPltConstants] = useState([]);
    const [user, setUser] = useState([]);
    const [error, setError] = useState({});
    const [dueDatePickerError, setDueDatePickerError] = useState(null);
    const [dueDateValue, setDueDateValue] = useState(() => addEditObligation?.data?.payment_due_date ? moment(addEditObligation.data.payment_due_date) : null);
    const [attachments, setAttachments] = useState([]);
    const [currencies,setCurrencies]=useState([]);

    useEffect(() => {
        if (addEditObligation?.data) {
            setData({
                ...addEditObligation.data,
                value: formatValue(addEditObligation.data.value),
            });
        }
        getPltConstants();
       if(modeType!=='view') getUserList();
        getCurrency();
    }, [addEditObligation?.data])

    const formatValue = (value) => {
        if (value === null || value === undefined || value === '') return '';
        const num = Number(value);
        if (isNaN(num)) return '';
        return num.toFixed(2);
    };

    const getCurrency = () => {
            setDropDownLoader(prev => ({ ...prev, currency: true }));
            globalGetService(getCurrencyApi(params))
                .then(response => {
                    if (checkApiStatus(response)) {
                        setCurrencies(response?.data?.data);
                    }
                    setDropDownLoader(prev => ({ ...prev, currency: false }));
                })
        }

    const getPltConstants = () => {
        setDropDownLoader(prev => ({ ...prev, constant: true }));
        globalPostService(getConsantApi(), { 'constant_types': ["obligation_type", "obligation_sub_type", "obligation_applicable", "obligation_frequency"] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setPltConstants(response?.data?.data);
                }
                setDropDownLoader(prev => ({ ...prev, constant: false }));
            })
    }

    const getUserList = () => {
        setDropDownLoader(prev => ({ ...prev, user: true }));
        globalGetService('/console/obligations/user_dropdown/')
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setUser(response?.data?.data);
                }
                setDropDownLoader(prev => ({ ...prev, user: false }));
            })
    }

    // const filterOptions = createFilterOptions({
    //     matchFrom: 'any',
    //     stringify: (option) => option?.first_name?.toLowerCase() || '',
    // });

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({attachments:files}))
    };
    const onFieldChange = (key, value) => {
        if(key === 'sub_type'){
            setData({ ...data, [key]: value, value : null, payment_due_date: null });
            setDueDatePickerError(null);
            setDueDateValue(null);
        } else if (key === 'obligation_type' && titanAviationIntance) {
            setData({ ...data, [key]: value, annual_inspection_date: null, next_financial_record: null });
        } else {
        setData({ ...data, [key]: value });}
        setError((prev) => ({ ...prev, [key]: '' }));
    };


    
    const onAddEditObligation = () => {
        let validationInputs = {};

        data?.sub_type?.value === 1 ? validationInputs = {
            ...validationInputs,
            obligation_type: data?.obligation_type ? "" : "Please select Type",
            // sub_type: data?.sub_type ? "" : "Please select Sub Type",
            // applicable: data?.applicable ? "" : "Please select Applicable To",
            to_be_approved_by: data?.to_be_approved_by ? "" : "Please select Approver",
            payment_due_date: dueDatePickerError === "invalidDate" ? "Please enter valid Due Date" : data?.payment_due_date ? "" : "Please select Due Date",
            value: data?.value ? "" : "Please enter Commercial Value",
            currency:data?.currency?"":"Please select Currency"
        } : validationInputs = {
            obligation_type: data?.obligation_type ? "" : "Please select Type",
            // sub_type: data?.sub_type ? "" : "Please select Sub Type",
            // applicable: data?.applicable ? "" : "Please select Applicable To",
                to_be_approved_by: data?.to_be_approved_by ? "" : "Please select Approver",
        };

        const dueDate = moment(data?.payment_due_date);
        if (data?.sub_type?.value === 1 && hasLeaseDateRange && data?.payment_due_date && dueDate.isValid() && (dueDate.isBefore(leaseStartDate, "day") || dueDate.isAfter(leaseEndDate, "day"))) {
            validationInputs.payment_due_date = "Due date must be within the lease period";
        }

        let payload = Object.assign({}, data)

        payload = { 
            id:payload?.id ? payload?.id : null,
            obligation_type: payload?.obligation_type?.value ? payload?.obligation_type?.value : null,
            sub_type: payload?.sub_type?.value ? payload?.sub_type?.value : null,
            value: payload?.value ? payload?.value : null,
            details: payload?.details ? payload?.details : null,
            applicable: payload?.applicable?.value ? payload?.applicable?.value : null,
            to_be_approved_by: payload?.to_be_approved_by?.id ? payload?.to_be_approved_by?.id : null,
            payment_due_date: payload?.payment_due_date ? payload?.payment_due_date : null,
            remarks: payload?.remarks ? payload?.remarks : null,
            currency: payload?.currency?.code ? payload.currency?.code : null,
            copies: payload?.copies ? payload?.copies : null,
            guarantor: payload?.guarantor ? payload?.guarantor : null,
            required: payload?.required ? payload?.required : null,
            frequency: payload?.frequency ? payload?.frequency?.value : null,
            ...(titanAviationIntance && payload?.obligation_type?.value === 1 && {
                annual_inspection_date: payload?.annual_inspection_date ? payload?.annual_inspection_date : null,
            }),
            ...(titanAviationIntance && payload?.obligation_type?.value === 5 && {
                next_financial_record: payload?.next_financial_record ? payload?.next_financial_record : null,
            }),
            ...(titanAviationIntance && {
                quarter_one: payload?.frequency?.value === 3 && payload?.quarter_one ? payload?.quarter_one : null,
                quarter_two: payload?.frequency?.value === 3 && payload?.quarter_two ? payload?.quarter_two : null,
                quarter_three: payload?.frequency?.value === 3 && payload?.quarter_three ? payload?.quarter_three : null,
                quarter_four: payload?.frequency?.value === 3 && payload?.quarter_four ? payload?.quarter_four : null,
            })
        }

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data.id) {
                globalPutService(editObligationApi({ ...params, slug: data?.slug }), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Obligation`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Obligation`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {
                globalPostService(addObligationApi(params), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Obligation`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Obligation`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Obligation`, error_msg: validationInputs, })
        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Obligation`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? "Add Obligations" : modeType === 'edit' ? 'Edit  Obligations' : 'View  Obligations '}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers >
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disabled={modeType === "view"}
                                disableClearable
                                disablePortal
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                loading={modeType !== "view" && dropDownLoader?.constant}
                                loadingText="Loading..."
                                noOptionsText={ modeType !== "view" && dropDownLoader?.obligation_type ? "Loading..." : "No Option Available" }
                                options={pltConstants?.filter(item => item.type === 'obligation_type')}
                                value={data?.obligation_type || null}
                                onChange={(e, value) => onFieldChange("obligation_type", value)}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow > <TextField {...params} label="Type" margin='normal' size='small' required
                                            error={error?.obligation_type}
                                            helperText={error?.obligation_type || ''} 
                                            slotProps={{
                                                inputLabel: { shrink: true, },
                                                input: {
                                                    ...params?.InputProps,
                                                    endAdornment: (<>
                                                        {modeType !== "view" && dropDownLoader?.constant && (
                                                            <CircularProgress color="inherit" size={20} />
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                    )
                                                }
                                            }} />
                                        </Tooltip>)}}
                            />
                        </Grid>
                        {titanAviationIntance && data?.obligation_type?.value === 1 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <TextField
                                    disabled={modeType === "view"}
                                    id="annual_inspection_date"
                                    label="Annual Inspection Date"
                                    variant="outlined"
                                    size='small'
                                    value={data?.annual_inspection_date || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("annual_inspection_date", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                    margin='normal'
                                    fullWidth
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                            </Grid> : null}
                        {titanAviationIntance && data?.obligation_type?.value === 5 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <TextField
                                    disabled={modeType === "view"}
                                    id="next_financial_record"
                                    label="Next Financial Record"
                                    variant="outlined"
                                    size='small'
                                    value={data?.next_financial_record || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("next_financial_record", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                    margin='normal'
                                    fullWidth
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                            </Grid> : null}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disabled={modeType === "view"}
                                disablePortal
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                noOptionsText={ modeType !== "view" && dropDownLoader?.constant ? "Loading..." : "No Option Available" }
                                options={pltConstants?.filter(item => item.type === 'obligation_sub_type')}
                                value={data?.sub_type || null}
                                onChange={(e, value) => onFieldChange("sub_type", value)}
                                renderInput={(params) => <TextField {...params} label="Sub Type" margin='normal' size='small' 
                                    slotProps={{
                                        inputLabel: { shrink: true, }, input: {
                                            ...params?.InputProps,
                                            endAdornment: (<>
                                                {modeType !== "view" && dropDownLoader?.constant && (
                                                    <CircularProgress color="inherit" size={20} />
                                                )}
                                                {params?.InputProps?.endAdornment}
                                            </>)
                                        }
                                    }}
                                />}
                            />
                        </Grid>
                        {data?.sub_type?.value === 1 ?
                            <>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <Autocomplete
                                        disablePortal
                                        disableClearable
                                        options={modeType === "view" ? data?.currency ? [data.currency] : [] :currencies}
                                        value={ modeType === "view" ? data?.currency || null : currencies.find(option => option?.code === data?.currency?.code) || null}
                                        disabled={modeType === "view"}
                                        getOptionLabel={(option) => option?.name || ""}
                                        noOptionsText={dropDownLoader?.currency ? "Loading..." : "No Option Available"}
                                        onFocus={() => setError({ ...error, currency: "" })}
                                        onChange={(e, value) => onFieldChange("currency", value)}
                                        isOptionEqualToValue={(option, value) => option.code === value.code}
                                        renderInput={(params) => {
                                            const selectedLabel = params?.inputProps?.value || "";
                                            return (
                                                <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                                    <TextField
                                                        {...params}
                                                        required={data?.sub_type?.value === 1}
                                                        label="Currency"
                                                        margin='normal'
                                                        size='small'
                                                        error={Boolean(error.currency)}
                                                        helperText={error.currency}
                                                        slotProps={{
                                                            inputLabel: { shrink: true },
                                                            input: { ...params?.InputProps, endAdornment: modeType !== "view" && dropDownLoader?.currency ? ( <CircularProgress color="inherit" size={20} /> ) : ( params.InputProps.endAdornment ), },
                                                        }}
                                                    />
                                                </Tooltip>)
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <TextField
                                        disabled={modeType === "view"}
                                        id="value"
                                        label="Commercial Value"
                                        variant="outlined"
                                        size='small'
                                        value={modeType === "view" && data?.value !== '' && data?.value !== null && data?.value !== undefined ? numberWithCommas(data?.value) : (data?.value || '')}
                                        onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('value', e.target.value) : e.preventDefault()}
                                        required
                                        margin='normal'
                                        fullWidth
                                        slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 10 }, input: { startAdornment: (<InputAdornment position="start">{data?.currency?.symbol}</InputAdornment>) }}} 
                                        error={error?.value}
                                        helperText={error?.value || ''}
                                    />
                                </Grid>
                            </> : null}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disabled={modeType === "view"}
                                disablePortal
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                loading={modeType !== "view" && dropDownLoader?.constant}
                                loadingText="Loading..."
                                noOptionsText={ modeType !== "view" && dropDownLoader?.constant ? "Loading..." : "No Option Available" }
                                options={pltConstants?.filter(item => item.type === 'obligation_applicable' )}
                                value={data?.applicable || null}
                                onChange={(e, value) => onFieldChange("applicable", value)}
                                renderInput={(params) => <TextField {...params} label="Applicable To" margin='normal' size='small'
                                    slotProps={{inputLabel: {shrink: true,},input:{ ...params?.InputProps,endAdornment: (<>{modeType !== "view" && dropDownLoader?.constant && ( <CircularProgress color="inherit" size={20} /> )} {params?.InputProps?.endAdornment}</> ) }}}/>}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            {/* {(() => {
                            let usersOption = user?.map((itemUser, index) => { return { ...itemUser, name: itemUser?.first_name + ' ' + itemUser?.last_name + ' ' + index }})
                            return( */}
                            <Autocomplete
                                disabled={modeType === "view"}
                                disableClearable
                                options={user || []}
                                getOptionLabel={(option) => {
                                    if (!option) return "";
                                    if (typeof option === "string") return option;
                                    return `${option.first_name ?? ""} ${option.last_name ?? ""}`.trim();
                                }}
                                noOptionsText={ modeType !== "view" && dropDownLoader?.user ? "Loading..." : "No Option Available" }
                                isOptionEqualToValue={(option, value) => option?.id === value.id}
                                filterOptions={(options, { inputValue }) =>
                                    options.filter((option) =>
                                        `${option?.first_name} ${option?.last_name}`.toLowerCase().includes(inputValue.toLowerCase())
                                    )
                                }
                                value={modeType === 'view' ? data?.to_be_approved_by?.name : user?.find(u => u.id === data?.to_be_approved_by?.id) || null}
                                onChange={(e, value) => onFieldChange("to_be_approved_by", value)}
                                renderOption={(props, option) => (
                                    <Tooltip title={option?.email || ''} placement="right" arrow>
                                        <li {...props}>
                                            {option?.first_name} {option?.last_name}
                                        </li>
                                    </Tooltip>
                                )}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                {...params}
                                                label="Approver"
                                                required
                                                size="small"
                                                slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.user && ( <CircularProgress color="inherit" size={20} /> )} {params?.InputProps?.endAdornment}</>) } }}
                                                error={!!error?.to_be_approved_by}
                                                helperText={error?.to_be_approved_by || ''}
                                            />
                                        </Tooltip> )}}
                            />

                            {/* )
                            })()} */}

                        </Grid>
                        {data?.sub_type?.value === 1 ? <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    disabled={modeType === "view"}
                                    label="Due Date"
                                    value={dueDateValue}
                                    onChange={(value) => {
                                        setDueDateValue(value);
                                        onFieldChange("payment_due_date", value && moment(value).isValid() ? moment(value).format(backendDateFormat) : null);
                                    }}
                                    onError={(reason) => setDueDatePickerError(reason)}
                                    slotProps={{ popper: { placement:'bottom-start' }, textField: { InputLabelProps: { shrink: true }, size: 'small', margin: 'normal', required: true, error: error.payment_due_date || false, helperText: error.payment_due_date || '', onFocus: () => { error.payment_due_date && setError((prev) => ({ ...prev, payment_due_date: '' })); }, } }}
                                    sx={{ width: '100%', height: '5' }}
                                    format={fieldDateFormat}
                                    minDate={leaseStartDate.isValid() ? leaseStartDate : undefined}
                                    maxDate={leaseEndDate.isValid() ? leaseEndDate : undefined}
                                />
                            </LocalizationProvider>
                        </Grid> : null }
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disabled={modeType === "view"}
                                disablePortal
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                loading={modeType !== "view" && dropDownLoader?.constant}
                                loadingText="Loading..."
                                noOptionsText={modeType !== "view" && dropDownLoader?.constant ? "Loading..." : "No Option Available"}
                                options={pltConstants?.filter(item => item.type === 'obligation_frequency')}
                                value={data?.frequency || null}
                                onChange={(e, value) => onFieldChange("frequency", value)}
                                renderInput={(params) => <TextField {...params} label="Frequency" margin='normal' size='small'
                                    error={error?.frequency}
                                    helperText={error?.frequency || ''} slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.constant && (<CircularProgress color="inherit" size={20} />)} {params?.InputProps?.endAdornment}</>) } }} />}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="copies"
                                label="Copies"
                                variant="outlined"
                                size='small'
                                value={data?.copies || ''}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("copies", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, copies: "" }));
                                }} 
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="guarantor"
                                label="Guarantor"
                                variant="outlined"
                                size='small'
                                value={data?.guarantor || ''}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("guarantor", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, guarantor: "" }));
                                }} 
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disabled={modeType === "view"}
                                options={[ { value: 1, label: "Yes" }, { value: 2, label: "No" } ]}
                                value={
                                    [{ value: 1, label: "Yes" }, { value: 2, label: "No" }]
                                        .find(option => option.value === data?.required) || null
                                }
                                isOptionEqualToValue={(option,value)=> option?.value==value?.value}
                                onChange={(e, value) => onFieldChange('required', value?.value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Required"
                                        margin='normal'
                                        size='small'
                                        slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, } }}
                                    />
                                )}
                            />
                        </Grid>
                        {titanAviationIntance && data?.frequency?.value === 3 ? (
                            <>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <DatePicker
                                            disabled={modeType === "view"}
                                            label="Quarter One"
                                            value={data?.quarter_one ? moment(data?.quarter_one) : null}
                                            onChange={(data) => onFieldChange("quarter_one", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                            slotProps={{ popper: { placement: 'bottom-start' }, textField: { InputLabelProps: { shrink: true }, size: 'small', margin: 'normal', error: error.quarter_one || false, helperText: error.quarter_one || '', } }}
                                            sx={{ width: '100%', height: '5' }}
                                            format={fieldDateFormat}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <DatePicker
                                            disabled={modeType === "view"}
                                            label="Quarter Two"
                                            value={data?.quarter_two ? moment(data?.quarter_two) : null}
                                            onChange={(data) => onFieldChange("quarter_two", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                            slotProps={{ popper: { placement: 'bottom-start' }, textField: { InputLabelProps: { shrink: true }, size: 'small', margin: 'normal', error: error.quarter_two || false, helperText: error.quarter_two || '', } }}
                                            sx={{ width: '100%', height: '5' }}
                                            format={fieldDateFormat}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <DatePicker
                                            disabled={modeType === "view"}
                                            label="Quarter Three"
                                            value={data?.quarter_three ? moment(data?.quarter_three) : null}
                                            onChange={(data) => onFieldChange("quarter_three", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                            slotProps={{ popper: { placement: 'bottom-start' }, textField: { InputLabelProps: { shrink: true }, size: 'small', margin: 'normal', error: error.quarter_three || false, helperText: error.quarter_three || '', } }}
                                            sx={{ width: '100%', height: '5' }}
                                            format={fieldDateFormat}
                                        />
                                    </LocalizationProvider>
                                </Grid> 
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <DatePicker
                                            disabled={modeType === "view"}
                                            label="Quarter Four"
                                            value={data?.quarter_four ? moment(data?.quarter_four) : null}
                                            onChange={(data) => onFieldChange("quarter_four", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                            slotProps={{ popper: { placement: 'bottom-start' }, textField: { InputLabelProps: { shrink: true }, size: 'small', margin: 'normal', error: error.quarter_four || false, helperText: error.quarter_four || '', } }}
                                            sx={{ width: '100%', height: '5' }}
                                            format={fieldDateFormat}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </>
                        ) : null}
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Details' value={data?.details || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    disabled={modeType === "view"}
                                    id="detail"
                                    label="Details"
                                    variant="outlined"
                                    size='small'
                                    value={data?.details || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("details", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, details: "" }));
                                    }} 
                                    margin='normal'
                                    fullWidth
                                    multiline
                                    rows={3}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                            </Grid>}
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    disabled={modeType === "view"}
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    value={data?.remarks || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, remarks: "" }));
                                    }} 
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    multiline
                                    rows={3}
                                />
                            </Grid>}
                        {/* <Grid size={{ md: 4, xs: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box className="check-item-div" sx={{cursor: modeType === "view" && "not-allowed"}}>
                                    <Checkbox disableRipple checked={data?.required === true ? true : false} onChange={(e) => onFieldChange('required', e.target.checked )} disabled={modeType === "view"} />
                                    <Typography className="check-item-span" fontSize='14px'>Required</Typography>
                                </Box>
                            </FormGroup>
                        </Grid> */}
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {data?.id && data?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditObligation?.data?.attachments?.length})Attachment(s)</Button> : null
                                }
                                <Button className="available-space-btn" disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === "view" ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className="cancel-btn" disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> {modeType === "view" ? "Close" : "Cancel"} </Button>
                    {modeType === "view" ? null : <Button size='small' variant='contained' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditObligation() }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>

    )
}
export default ObligationsCRU;